import { Point } from '../redux/types';

export const timestampAscending = (a: Point, b: Point) =>
  a.timestamp < b.timestamp ? -1 : a.timestamp > b.timestamp ? 1 : 0;

export const timestampDescending = (a: Point, b: Point) =>
  a.timestamp > b.timestamp ? -1 : a.timestamp < b.timestamp ? 1 : 0;
